import { PromotionPlatform, PromotionStatus } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const promotionStatusColorMap: Record<PromotionStatus, BadgeColor> = {
  [PromotionStatus.Active]: "green",
  [PromotionStatus.Paused]: "yellow",
  [PromotionStatus.Archived]: "zinc",
};

export const promotionPlatformLabelMap: Record<PromotionPlatform, string> = {
  [PromotionPlatform.Openai]: "OpenAI",
  [PromotionPlatform.Meta]: "Meta",
  [PromotionPlatform.Google]: "Google",
  [PromotionPlatform.Tiktok]: "TikTok",
};
